// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var JsxRuntime = require("react/jsx-runtime");
var UrlValidator = require("../../../packs/UrlValidator");
var RedirectionUrl$ReactHooksTemplate = require("../surveys/redirectionUrl.res.js");
var GooglePlacesSearch$ReactHooksTemplate = require("./GooglePlacesSearch.res.js");

function validateUrl(prim) {
  return UrlValidator.validateUrl(prim);
}

function RedirectionUrlForm(props) {
  var onFormSubmit = props.onFormSubmit;
  var selectedRedirectionUrl = props.selectedRedirectionUrl;
  var toggleModal = props.toggleModal;
  var match = React.useState(function (param) {
        return selectedRedirectionUrl;
      });
  var setRedirectionUrl = match[1];
  var redirectionUrl = match[0];
  var match$1 = React.useState(function (param) {
        return false;
      });
  var setNameError = match$1[1];
  var nameError = match$1[0];
  var match$2 = React.useState(function (param) {
        return false;
      });
  var setUrlError = match$2[1];
  var urlError = match$2[0];
  var match$3 = React.useState(function (param) {
        if (RedirectionUrl$ReactHooksTemplate.isGoogleReviewUrl(selectedRedirectionUrl)) {
          return "GoogleReviewMode";
        } else {
          return "PromptMode";
        }
      });
  var setInputMode = match$3[1];
  var inputMode = match$3[0];
  var containsInvalidChar = function (specialCharRegex, words) {
    return List.exists((function (word) {
                  return List.exists((function (x) {
                                return Caml_obj.equal(word, x);
                              }), specialCharRegex);
                }), words);
  };
  var handleNameChange = function (e) {
    var name = e.target.value;
    var words = Belt_List.fromArray(Js_string.split("", name));
    var error = containsInvalidChar({
          hd: "<",
          tl: {
            hd: "!",
            tl: {
              hd: "=",
              tl: {
                hd: "+",
                tl: {
                  hd: "-",
                  tl: {
                    hd: "@",
                    tl: {
                      hd: ">",
                      tl: {
                        hd: "?",
                        tl: {
                          hd: "'",
                          tl: {
                            hd: "\"",
                            tl: {
                              hd: "$",
                              tl: {
                                hd: "#",
                                tl: {
                                  hd: "%",
                                  tl: {
                                    hd: "^",
                                    tl: {
                                      hd: "*",
                                      tl: {
                                        hd: "(",
                                        tl: {
                                          hd: ")",
                                          tl: {
                                            hd: "/",
                                            tl: {
                                              hd: ".",
                                              tl: {
                                                hd: "&",
                                                tl: {
                                                  hd: ",",
                                                  tl: {
                                                    hd: ";",
                                                    tl: {
                                                      hd: "`",
                                                      tl: {
                                                        hd: "~",
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }, words);
    Curry._1(setNameError, (function (param) {
            return error;
          }));
    Curry._1(setRedirectionUrl, (function (param) {
            return RedirectionUrl$ReactHooksTemplate.setName(redirectionUrl, name);
          }));
  };
  var handleUrlChange = function (e) {
    var url = e.target.value;
    Curry._1(setUrlError, (function (param) {
            return !UrlValidator.validateUrl(url);
          }));
    Curry._1(setRedirectionUrl, (function (param) {
            return RedirectionUrl$ReactHooksTemplate.setUrl(redirectionUrl, url);
          }));
  };
  var handleGooglePlaceSelect = function (place) {
    Curry._1(setRedirectionUrl, (function (prevUrl) {
            return RedirectionUrl$ReactHooksTemplate.setGooglePlaceId(RedirectionUrl$ReactHooksTemplate.setIsGoogleReviewUrl(RedirectionUrl$ReactHooksTemplate.setUrl(prevUrl, place.reviewUrl), true), place.placeId);
          }));
    Curry._1(setUrlError, (function (param) {
            return false;
          }));
  };
  var tmp;
  switch (inputMode) {
    case "PromptMode" :
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: "What type of URL would you like to add?",
                              className: "text-lg font-semibold text-gray-900 mb-2"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Choose whether this is a Google review URL or a regular URL",
                              className: "text-sm text-gray-600"
                            })
                      ],
                      className: "mb-6"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "⭐",
                                            className: "text-2xl mb-2"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: "Google Review URL",
                                            className: "font-semibold"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: "Let customers leave reviews",
                                            className: "text-xs text-blue-100 mt-1"
                                          })
                                    ],
                                    className: "flex flex-col items-center"
                                  }),
                              className: "flex-1 max-w-xs px-6 py-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 shadow-md hover:shadow-lg",
                              onClick: (function (param) {
                                  Curry._1(setInputMode, (function (param) {
                                          return "GoogleReviewMode";
                                        }));
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "🔗",
                                            className: "text-2xl mb-2"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: "Regular URL",
                                            className: "font-semibold"
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: "Any website or link",
                                            className: "text-xs text-gray-100 mt-1"
                                          })
                                    ],
                                    className: "flex flex-col items-center"
                                  }),
                              className: "flex-1 max-w-xs px-6 py-4 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-lg hover:from-gray-600 hover:to-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-all duration-200 shadow-md hover:shadow-lg",
                              onClick: (function (param) {
                                  Curry._1(setInputMode, (function (param) {
                                          return "RegularUrlMode";
                                        }));
                                })
                            })
                      ],
                      className: "flex flex-col sm:flex-row gap-4 justify-center"
                    })
              ],
              className: "text-center py-8"
            });
        break;
    case "GoogleReviewMode" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "ℹ",
                                            className: "text-blue-600 text-xl mr-2"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("p", {
                                                    children: "Setting up Google Review URL",
                                                    className: "text-sm font-medium text-blue-900 mb-1"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Search for your business and select it from the results",
                                                    className: "text-xs text-blue-700"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-start"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Change type",
                                    className: "text-xs text-blue-600 hover:text-blue-800 underline whitespace-nowrap",
                                    onClick: (function (param) {
                                        Curry._1(setInputMode, (function (param) {
                                                return "PromptMode";
                                              }));
                                      })
                                  })
                            ],
                            className: "flex items-start justify-between"
                          }),
                      className: "bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Name",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                RedirectionUrl$ReactHooksTemplate.name(redirectionUrl).length === 0 || nameError ? "border-red-300" : "border-gray-300"
                              ),
                              maxLength: 100,
                              placeholder: "e.g., Main Branch Review",
                              type: "text",
                              value: RedirectionUrl$ReactHooksTemplate.name(redirectionUrl),
                              onChange: handleNameChange
                            }),
                        RedirectionUrl$ReactHooksTemplate.name(redirectionUrl).length === 0 ? JsxRuntime.jsx("p", {
                                children: "Name can't be empty",
                                className: "mt-1 text-xs text-red-600"
                              }) : (
                            nameError ? JsxRuntime.jsx("p", {
                                    children: "Special characters are not allowed",
                                    className: "mt-1 text-xs text-red-600"
                                  }) : null
                          )
                      ]
                    }),
                JsxRuntime.jsx(GooglePlacesSearch$ReactHooksTemplate.make, {
                      onPlaceSelect: handleGooglePlaceSelect,
                      onCancel: toggleModal
                    })
              ]
            });
        break;
    case "RegularUrlMode" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("span", {
                                            children: "🔗",
                                            className: "text-gray-600 text-xl mr-2"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("p", {
                                                    children: "Regular URL",
                                                    className: "text-sm font-medium text-gray-900 mb-1"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Add any website or link",
                                                    className: "text-xs text-gray-600"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-start"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Change type",
                                    className: "text-xs text-gray-600 hover:text-gray-800 underline",
                                    onClick: (function (param) {
                                        Curry._1(setInputMode, (function (param) {
                                                return "PromptMode";
                                              }));
                                      })
                                  })
                            ],
                            className: "flex items-start justify-between"
                          }),
                      className: "bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Name",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                RedirectionUrl$ReactHooksTemplate.name(redirectionUrl).length === 0 || nameError ? "border-red-300" : "border-gray-300"
                              ),
                              maxLength: 100,
                              placeholder: "Enter a descriptive name",
                              type: "text",
                              value: RedirectionUrl$ReactHooksTemplate.name(redirectionUrl),
                              onChange: handleNameChange
                            }),
                        RedirectionUrl$ReactHooksTemplate.name(redirectionUrl).length === 0 ? JsxRuntime.jsx("p", {
                                children: "Name can't be empty",
                                className: "mt-1 text-xs text-red-600"
                              }) : (
                            nameError ? JsxRuntime.jsx("p", {
                                    children: "Special characters are not allowed",
                                    className: "mt-1 text-xs text-red-600"
                                  }) : null
                          )
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "URL",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full px-3 py-2 border rounded-lg font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                RedirectionUrl$ReactHooksTemplate.url(redirectionUrl).length === 0 || urlError ? "border-red-300" : "border-gray-300"
                              ),
                              maxLength: 100,
                              placeholder: "https://example.com/redirect",
                              type: "text",
                              value: RedirectionUrl$ReactHooksTemplate.url(redirectionUrl),
                              onChange: handleUrlChange
                            }),
                        RedirectionUrl$ReactHooksTemplate.url(redirectionUrl).length === 0 ? JsxRuntime.jsx("p", {
                                children: "URL can't be empty",
                                className: "mt-1 text-xs text-red-600"
                              }) : (
                            urlError ? JsxRuntime.jsx("p", {
                                    children: "Not a valid URL",
                                    className: "mt-1 text-xs text-red-600"
                                  }) : JsxRuntime.jsx("p", {
                                    children: "Enter a valid HTTP or HTTPS URL",
                                    className: "mt-1 text-xs text-gray-500"
                                  })
                          )
                      ]
                    })
              ]
            });
        break;
    
  }
  var tmp$1;
  var exit = 0;
  switch (inputMode) {
    case "PromptMode" :
        tmp$1 = null;
        break;
    case "GoogleReviewMode" :
    case "RegularUrlMode" :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("button", {
                  children: "Cancel",
                  className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                  onClick: (function (param) {
                      Curry._1(toggleModal, undefined);
                    })
                }),
            JsxRuntime.jsx("button", {
                  children: "Save URL",
                  className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                    RedirectionUrl$ReactHooksTemplate.name(redirectionUrl).length === 0 || RedirectionUrl$ReactHooksTemplate.url(redirectionUrl).length === 0 || urlError || nameError ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                  ),
                  disabled: RedirectionUrl$ReactHooksTemplate.name(redirectionUrl).length === 0 || RedirectionUrl$ReactHooksTemplate.url(redirectionUrl).length === 0 || urlError || nameError,
                  onClick: (function (param) {
                      Curry._1(onFormSubmit, redirectionUrl);
                    })
                })
          ],
          className: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: tmp,
                      className: "p-6 space-y-6"
                    }),
                tmp$1
              ],
              className: "flex flex-col"
            });
}

var make = RedirectionUrlForm;

exports.validateUrl = validateUrl;
exports.make = make;
/* react Not a pure module */
